
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/energy-insights",
      function () {
        return require("private-next-pages/energy-insights/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/energy-insights"])
      });
    }
  